import React, {useState} from 'react';
import {Typography, Tag as AntTag, Tooltip} from 'antd';
import Tag from "../Tag/Tag";
import {RECOGNIZER_LABELS} from "../util/constants";

const {Text} = Typography;

const AnalyzedText = (props) => {

    const {text, analysis, allTags} = props;
    const [renderValue, setRenderValue] = useState([]);

    React.useEffect(() => {
        if (analysis && Array.isArray(analysis) && analysis.length > 0) {
            // Sort by start position, then prefer longer spans, then higher scores
            const sorted = [...analysis].sort((a, b) => {
                if (a.start !== b.start) return a.start - b.start;
                const lenA = a.end - a.start, lenB = b.end - b.start;
                if (lenA !== lenB) return lenB - lenA;
                return (b.score || 0) - (a.score || 0);
            });

            // Filter out overlapping entities — keep the first (longest/highest-scoring) one
            const filtered = [];
            let lastEnd = -1;
            for (const s of sorted) {
                if (s.start >= lastEnd) {
                    filtered.push(s);
                    lastEnd = s.end;
                }
            }

            const result = [];
            let lastIndex = 0;

            filtered.forEach(({start, end, type, recognizer, score}) => {
                if (start > lastIndex) {
                    result.push({val: text.slice(lastIndex, start), type: "text"});
                }
                result.push({val: text.slice(start, end), type: "tag", tag: type, start, end, recognizer, score});
                lastIndex = end;
            });

            if (lastIndex < text.length) {
                result.push({val: text.slice(lastIndex), type: "text"});
            }
            setRenderValue(result);
        } else {
            setRenderValue([{val: text, type: "text"}]);
        }
    }, [analysis, text]);

    return (
        <div style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "baseline",
            gap: 2,
            lineHeight: 1.8,
        }}>
            {
                renderValue.map((rval, i) => {
                    if (rval.type === "text") {
                        return (
                            <Text key={"text-" + i} style={{whiteSpace: "pre-wrap"}}>{rval.val}</Text>
                        );
                    } else {
                        const tagEntry = allTags && allTags.find(tag => tag.tag === rval.tag);
                        const color = tagEntry ? tagEntry.color : "#ef7721";
                        const recognizerLabel = RECOGNIZER_LABELS[rval.recognizer];
                        return (
                            <Tooltip
                                key={"tag-" + i}
                                title={[
                                    rval.score ? `${(rval.score * 100).toFixed(1)}%` : null,
                                    recognizerLabel
                                ].filter(Boolean).join(" \u2014 ")}
                            >
                                <span style={{display: "inline-flex", alignItems: "center"}}>
                                    <Tag tagName={rval.tag} mytype="TAG" color={color}>{rval.val}</Tag>
                                </span>
                            </Tooltip>
                        );
                    }
                })
            }
        </div>
    );
};

export default AnalyzedText;
